'use strict';

var pMap = require('p-map');

module.exports = function (iterable, options) {
  return pMap(iterable, function (element) {
    return element();
  }, options);
}; // TODO: Remove this for the next major release


module.exports["default"] = module.exports;